import React from 'react'
import {NavLink} from "react-router-dom"
import logo_drive from "../images/google-disc-logo.png"
import logo_drive_mail from "../images/gmail-logo-512.png"
import {shortEmail} from "../functions"

export class MainPageAuthClass extends React.Component {

    render() {

        const {lang, auth, currentLang, linkMyLinks} = this.props

        const objLinks = {
            admin: {
                "name": lang.navbar.isAuth.btnAdmin,
                "link": `/${currentLang}/admin`,
                "className": "Admin",
                "bodyClass": ""
            },
            myLinks: {
                "name": lang.navbar.isAuth.btnMyLinks,
                "link": `/${currentLang}/folder/open/${linkMyLinks}`,
                "className": "MyLinks",
                "bodyClass": ""
            },
            money: {
                "name": lang.navbar.isAuth.btnMoney,
                "link": `/${currentLang}/money/main`,
                "className": "Money",
                "bodyClass": ""
            },
            publicLinks: {
                "name": lang.navbar.isAuth.btnPublicLinks,
                "link": `/${currentLang}/folder/open-public/666a0310c1c139c28daa572b`,
                "className": "PublicLinks",
                "bodyClass": ""
            },
            profile: {
                "name": lang.navbar.isAuth.btnProfile,
                "link": `/${currentLang}/profile`,
                "className": "Profile",
                "bodyClass": ""
            },
            out: {
                "name": lang.navbar.isAuth.btnOut,
                "link": `/${currentLang}/exit`,
                "className": "Out",
                "bodyClass": "exit"
            },
            updateLang: {
                "name": lang.navbar.isAuth.btnUpdateLang,
                "link": `/${currentLang}/update-lang`,
                "className": "update-lang",
                "bodyClass": ""
            },
            help: {
                "name": lang.navbar.isAuth.askHelp,
                "link": `/${currentLang}/help`,
                "className": "Help",
                "bodyClass": ""
            },
            netphone: {
                "name": lang.navbar.isAuth.btnNetphone,
                "link": `/${currentLang}/net-phone`,
                "className": "Net-phone",
                "bodyClass": "net-phone"
            },
            googleDrive: {
                "name": lang.navbar.isAuth.btnGoogleDrive,
                "link": `/${currentLang}/google-drive/open/root`,
                "className": "Google-drive",
                "bodyClass": ""
            },
            googleMail: {
                "name": shortEmail(auth.email, 10),
                "link": `https://accounts.google.com/AccountChooser?service=mail&continue=https://mail.google.com/mail/`,
                "className": "Google-mail",
                "bodyClass": ""
            }
        }

        return (
            <>
                <div className={"d-flex justify-content-center flex-wrap"}>

                    {false && <NavLink
                        to={`${objLinks.netphone.link}`}
                        className={`card text-decoration-none m-3 col-10 col-lg-3 col-sm-4 ${objLinks.netphone.className}`}>
                        <div className={"m-1 w-auto"}>
                            <div className={`card border-primary p-3 text-center ${objLinks.netphone.bodyClass}`}>
                                <div className={"card-body text-success pt-1 ps-2 pe-2 pb-0"}>
                                    <h5 className={"card-title title-card"}><strong
                                        id={'main-page-button-' + 0}>{objLinks.netphone.name}</strong>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </NavLink>}

                    {auth.authenticatedVia === 'google' && <NavLink
                        to={`${objLinks.googleDrive.link}`}
                        className={`card text-decoration-none m-3 col-10 col-lg-3 col-sm-4 ${objLinks.googleDrive.className}`}>
                        <div className={"m-1 w-auto"}>
                            <div className={`card border-primary p-3 text-center ${objLinks.googleDrive.bodyClass}`}>
                                <div
                                    className={"col col-11 card-body d-flex flex-nowrap text-success pt-1 ps-2 pe-2 pb-0"}>
                                    <div className={'col col-2'}>
                                        <img style={{margin: '-20px', width: '50px', height: '50px'}} src={logo_drive}
                                             alt="Google Drive"/>
                                    </div>
                                    <div className={'col col-9'}>
                                        <h5 className={"card-title title-card"}>
                                            <strong style={{paddingLeft: '20px'}}
                                                    id={'main-page-button-' + 1}>
                                                {objLinks.googleDrive.name}
                                            </strong>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </NavLink>}
                    {auth.authenticatedVia === 'google' && <NavLink
                        to={`${objLinks.googleMail.link}`}
                        className={`card text-decoration-none m-3 col-10 col-lg-3 col-sm-4 ${objLinks.googleMail.className}`}
                        target={"_blank"}>
                        <div className={"m-1 w-auto"}>
                            <div className={`card border-primary p-3 text-center ${objLinks.googleMail.bodyClass}`}>
                                <div className={"col col-11 card-body d-flex flex-nowrap text-success pt-1 ps-2 pe-2 pb-0"}>
                                    <div className={'col col-2'}>
                                        <img style={{margin: '-20px', width: '50px', height: '50px'}} src={logo_drive_mail}
                                             alt="Google Mail"/>
                                    </div>
                                    <div className={'col col-11'}>
                                        <h5 className={"card-title title-card"}>
                                            <strong style={{paddingLeft: '10px'}}
                                                    id={'main-page-button-' + 1}>
                                                {objLinks.googleMail.name}
                                            </strong>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </NavLink>}

                    <NavLink
                        to={`${objLinks.myLinks.link}`}
                        className={`card text-decoration-none m-3 col-10 col-lg-3 col-sm-4 ${objLinks.myLinks.className}`}>
                        <div className={"m-1 w-auto"}>
                            <div className={`card border-primary p-3 text-center ${objLinks.myLinks.bodyClass}`}>
                                <div className={"card-body text-success pt-1 ps-2 pe-2 pb-0"}>
                                    <h5 className={"card-title title-card"}><strong
                                        id={'main-page-button-' + 2}>{objLinks.myLinks.name}</strong>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </NavLink>

                    <NavLink
                        to={`${objLinks.money.link}`}
                        className={`card text-decoration-none m-3 col-10 col-lg-3 col-sm-4 ${objLinks.money.className}`}>
                        <div className={"m-1 w-auto"}>
                            <div className={`card border-primary p-3 text-center ${objLinks.money.bodyClass}`}>
                                <div className={"card-body text-success pt-1 ps-2 pe-2 pb-0"}>
                                    <h5 className={"card-title title-card"}><strong
                                        id={'main-page-button-' + 3}>{objLinks.money.name}</strong>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </NavLink>

                    {(currentLang === 'ru') && <NavLink
                        to={`${objLinks.publicLinks.link}`}
                        className={`card text-decoration-none m-3 col-10 col-lg-3 col-sm-4 ${objLinks.publicLinks.className}`}>
                        <div className={"m-1 w-auto"}>
                            <div className={`card border-primary p-3 text-center ${objLinks.publicLinks.bodyClass}`}>
                                <div className={"card-body text-success pt-1 ps-2 pe-2 pb-0"}>
                                    <h5 className={"card-title title-card"}><strong
                                        id={'main-page-button-' + 4}>{objLinks.publicLinks.name}</strong>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </NavLink>}

                    <NavLink to={`${objLinks.profile.link}`}
                             className={`card text-decoration-none m-3 col-10 col-lg-3 col-sm-4 ${objLinks.profile.className}`}>
                        <div className={"m-1 w-auto"}>
                            <div className={`card border-primary p-3 text-center ${objLinks.profile.bodyClass}`}>
                                <div className={"card-body text-success pt-1 ps-2 pe-2 pb-0"}>
                                    <h5 className={"card-title title-card"}><strong
                                        id={'main-page-button-' + 5}>{objLinks.profile.name}</strong>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </NavLink>

                    {false && <NavLink
                        to={`${objLinks.help.link}`}
                        className={`card text-decoration-none m-3 col-10 col-lg-3 col-sm-4 ${objLinks.help.className}`}>
                        <div className={"m-1 w-auto"}>
                            <div className={`card border-primary p-3 text-center ${objLinks.help.bodyClass}`}>
                                <div className={"card-body text-success pt-1 ps-2 pe-2 pb-0"}>
                                    <h5 className={"card-title title-card"}><strong
                                        id={'main-page-button-' + 6}>{objLinks.help.name}</strong>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </NavLink>}

                    {auth.superUser && <NavLink
                        to={`${objLinks.admin.link}`}
                        className={`card text-decoration-none m-3 col-10 col-lg-3 col-sm-4 ${objLinks.admin.className}`}>
                        <div className={"m-1 w-auto"}>
                            <div className={`card border-primary p-3 text-center ${objLinks.admin.bodyClass}`}>
                                <div className={"card-body text-success pt-1 ps-2 pe-2 pb-0"}>
                                    <h5 className={"card-title title-card"}><strong
                                        id={'main-page-button-' + 7}>{objLinks.admin.name}</strong>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </NavLink>}

                    <NavLink
                        to={`${objLinks.out.link}`}
                        className={`card text-decoration-none m-3 col-10 col-lg-3 col-sm-4 ${objLinks.out.className}`}>
                        <div className={"m-1 w-auto"}>
                            <div className={`card border-primary p-3 text-center ${objLinks.out.bodyClass}`}>
                                <div className={"card-body text-success pt-1 ps-2 pe-2 pb-0"}>
                                    <h5 className={"card-title title-card"}><strong
                                        id={'main-page-button-' + 8}>{objLinks.out.name}</strong>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </NavLink>

                </div>
            </>
        )
    }
}
